import React from "react";
import { compose } from "redux";
import { Menu, MenuItem, Avatar, Badge } from "@material-ui/core";
import { Link } from "react-router-dom";
import styled from "styled-components";
import SettingsIcon from "@material-ui/icons/Settings";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { logoutRequest } from "store/state/auth";
import { connect } from "react-redux";

const MenuButton = styled.div`&& {
    text-align: center;    
    margin-right:10px;
    text-transform: none;

    #profileDropdownButton:hover {
      background-color: red;
    }

    pointer-events: ${({ disabled }) => disabled ? "none" : ""};
  }`;

const MenuClass = "MenuStyles";
const MenuStyles = styled(Menu)
  .attrs({ classes: { paper: MenuClass } })`
  .${MenuClass} {
    min-width: 125px;
    max-width: 220px;
    top: 50px !important;
    right: 5px !important;
  }`;

class UserMenu extends React.Component {
  state = {
    anchorEl: null
  };

  componentDidUpdate(prevProps) {
    if (this.props.isStatic && !prevProps.isStatic && this.state.anchorEl) {
      this.setState({ anchorEl: null });
    }
  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleLogout = () => {
    this.props.logoutRequest();
  };

  render() {
    const { anchorEl } = this.state;
    const { authentication, disabled, isStatic } = this.props;
    const displayInitals = authentication.user.contact ? authentication.user.contact.firstName[0] + authentication.user.contact.lastName[0] : authentication.user.name;
    const initialsBadge = <Badge overlap="circular" anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} variant="dot" ><Avatar>{displayInitals}</Avatar></Badge>;

    if (isStatic) {
      return (<MenuButton id="profileBadge">{initialsBadge}</MenuButton>);
    }

    return (
      <>
        <MenuButton disabled={disabled} disableRipple aria-owns={anchorEl ? "user-menu" : null} aria-haspopup="true" id="profileDropdownButton" onClick={this.handleClick} >
          {initialsBadge}
        </MenuButton>
        <MenuStyles id="simple-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={this.handleClose} >
          {(this.props.authentication.user.roles.includes("systemAdmin") || this.props.authentication.user.roles.includes("companyAdmin")) ? (<MenuItem id="profileDropdown-AdminButton" onClick={this.handleClose} component={Link} to={this.props.authentication.user.roles.includes("systemAdmin") ? "/admin/libor" : "/admin/contacts"} ><SettingsIcon /> Admin</MenuItem>) : null}
          <MenuItem onClick={this.handleLogout} id="profileDropdown-LogoutButton"><ExitToAppIcon /> Logout</MenuItem>
        </MenuStyles>
      </>
    );
  }
}

const mapStateToProps = ({ authentication }) => ({ authentication });

export default compose(
  connect(mapStateToProps, { logoutRequest })
)(UserMenu);
